import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Routes } from '../../../../app/routes';

const Forbidden = (): JSX.Element => {
  const { t } = useTranslation('auth');

  return (
    <Result
      status="403"
      title={t('forbidden.title')}
      subTitle={t('forbidden.subTitle')}
      extra={
        <Link to={Routes.Main}>
          <Button type="primary">{t('forbidden.actions.home')}</Button>
        </Link>
      }
    />
  );
};

export default Forbidden;
